import React from 'react';
import PropTypes from 'prop-types';
import Covid19Constants from '../../../common/Covid19Constants';
import './Dashboard.scss';

const Covid19Tile = (props) => {
  const { customerInfo } = props;
  if (!customerInfo.requestInProgress && customerInfo.connected) {
    return (
      <div id="move-address-tile" className="account-action-tile">
        <div className="account-action-tile-title">
          {Covid19Constants.dashboard.title}
        </div>
        <div className="account-action-tile-text">
          {Covid19Constants.dashboard.message}
        </div>
      </div>
    );
  }
  return null;
};

Covid19Tile.propTypes = {
  customerInfo: PropTypes.object.isRequired
};

export default Covid19Tile;



/** WEBPACK FOOTER **
 ** ./src/components/myaccount/Dashboard/Covid19Tile.js
 **/